import { render, staticRenderFns } from "./Order-payment.vue?vue&type=template&id=f9f3426c"
import script from "./Order-payment.vue?vue&type=script&lang=js"
export * from "./Order-payment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports